// import './header.scss'
  
function init() {
  // var myElement = document.getElementById("header");
  // var headroom = new Headroom(myElement);
  // headroom.init();
}

export default init